import Search from "../../../components/Search/CommonSearch";
import PropTypes from "prop-types";
import { Stack, Chip } from "@mui/material";
import { chipFilterConfig } from "../../../utils/constants";
import StatusBreakdownPopover from "../../../components/WorkflowBreakdown";
import PillDropdown from "../../../components/PillDropdown/PillDropdown";
import RemindersButton from "../Reminders/RemindersButton";

const FilterBar = ({
  activeTab,
  handleSelect,
  isLoading,
  handleFilterChange,
  filterState,
  handleStateChange,
  statusOptions,
  dueOnOptions,
  getChipCount,
  handleChangePageSize,
}) => {

  const isEsign =
    activeTab === "sentForSignature" || activeTab === "needsMySignature";
  const isSendVA = activeTab === "veteransAffairs";
  const getSearchPlaceholder = () => {
    if (isSendVA) return "Search File/ Sent by";
    if (isEsign) return "Search file";
    if (activeTab === "messages") return "Search messages";
    return "Search by file";
  };

  const searchPlaceholder = getSearchPlaceholder();
    
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16, gap: 16 }}>
      <Stack direction="row" spacing={1} sx={{ overflowX: 'auto', pb: 1 }}>
        {chipFilterConfig[activeTab].map((chip) => {
          const isSelected = chip.key === filterState[activeTab].chip_status;

          return (
            <Chip
              key={chip.key}
              label={`${chip.label} (${getChipCount(chip.countKey)})`} // replace 12 with dynamic count if needed
              onClick={() => handleFilterChange({ label: 'chip_status', value: chip.key })}
              clickable
              variant="outlined"
              sx={{
                fontFamily: 'manrope',
                backgroundColor: isSelected ? '#F1F6FE' : '#fff',
                border: isSelected ? '1px solid #DAE6F7' : '1px solid #E0E0E0',
                color: isSelected ? '#0C53BB' : '#333',
                '&:hover': {
                  backgroundColor: '#EDF3FC',
                },
              }}
            />
          );
        })}
      </Stack>

      <div style={{ display: 'flex', alignItems: 'center', gap: 22, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {activeTab === "sentForSignature" ? (
            <StatusBreakdownPopover type="Esign" />
          ) : null}
          {activeTab === "myReview" ? <RemindersButton /> : null}
          {activeTab === "myReview" || activeTab === "sharedReview" ? (
            <PillDropdown
              key={activeTab + '-dueon'}
              handleChange={(e) => handleSelect({ label: 'due_on', value: e })}
              value={filterState[activeTab]?.due_on}
              options={dueOnOptions}
              placeholder="Due on"
            />
          ) : null}
          {/* Tasks express status through the chips, and the endpoint
              has no `status` parameter, so a second status control
              here would be inert. */}
          {!["tasks", "messages"].includes(activeTab) ? (
            <PillDropdown
              key={activeTab + '-status'}
              handleChange={(e) => handleSelect({ label: 'status', value: e })}
              value={filterState[activeTab].status}
              options={statusOptions}
              placeholder="Status"
            />
          ) : null}
        </div>
        <div style={{ flexShrink: 0, minWidth: 300 }}>
          <Search
            searchPlaceholder={searchPlaceholder}
            isLoading={isLoading}
            handleSearch={(e) => handleFilterChange({ label: 'search', value: e })}
            handleSearchOnChange={(e) => handleStateChange({ label: 'search', value: e })}
            inputValue={filterState[activeTab]?.search}
            searchbarwidth="300px"
          />
        </div>
      </div>
    </div>
  );
};

FilterBar.propTypes = {
  activeTab: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  filterState: PropTypes.objectOf(PropTypes.shape({
    chip_status: PropTypes.string,
    status: PropTypes.string,
    due_on: PropTypes.string,
    search: PropTypes.string,
    page: PropTypes.number,
    page_size: PropTypes.string,
    attorney: PropTypes.string,
  })).isRequired,
  handleStateChange: PropTypes.func.isRequired,
  statusOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  dueOnOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),
  getChipCount: PropTypes.func.isRequired,
  handleChangePageSize: PropTypes.func,
};

export default FilterBar;
